import { createLabeledMessages } from '../../../messageUtils';
const copy = {
    saved: 'uložené do schránky!'
};
export default Object.assign({}, copy, createLabeledMessages(copy));
